/**
 * SuggestionChips — 후속 질문 칩 목록
 *
 * AssistantMessage.suggestions 배열 기반
 * 클릭 시 send(suggestion) 호출
 */

import { cn } from "@/shared/lib/utils";

export interface SuggestionChipsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  disabled?: boolean;
  className?: string;
}

export function SuggestionChips({
  suggestions,
  onSelect,
  disabled = false,
  className,
}: SuggestionChipsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className={cn("flex flex-wrap gap-2 mt-3", className)}>
      {suggestions.map((suggestion, i) => (
        <button
          key={i}
          type="button"
          onClick={() => !disabled && onSelect(suggestion)}
          disabled={disabled}
          className={cn(
            "rounded-full border border-stroke-subtle bg-surface-raised px-3 py-1.5",
            "text-[11px] font-medium text-text-primary",
            "hover:bg-surface-secondary hover:border-accent/30 transition-colors",
            "disabled:cursor-not-allowed disabled:opacity-50",
          )}
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
